import { useUserStore } from '@/stores/user'
import { createRouter, createWebHistory } from 'vue-router'

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    {
      path: '/login',
      alias: '/login',
      name: 'login',
      component: () => import('@/views/LoginView.vue')
    },
    {
      path: '/myaccount',
      alias: '/',
      name: 'account',
      component: () => import('@/views/Account/index.vue'),
      redirect: { name: 'account_home' },
      // 'subscriptions' and 'profile' below use absolute paths, so Vue Router does not
      // actually nest them under /myaccount -- grouping them here only shares the auth
      // guard and Account/index.vue shell. use/navItems.js's tree must mirror this
      // parent/children shape or AppBreadcrumbs' findTitlePath will render the wrong trail.
      children: [
        {
          path: '',
          name: 'account_home',
          component: () => import('@/views/Account/MyAccountView.vue'),
          meta: {
            title: 'My Account'
          }
        },
        {
          path: '/subscriptions',
          name: 'account_subscriptions',
          component: () => import('@/views/Account/SubscriptionsView.vue'),
          meta: {
            title: 'My Subscriptions'
          }
        },
        {
          path: '/profile',
          name: 'account_profile',
          component: () => import('@/views/Account/ProfileView.vue'),
          meta: {
            title: 'My Profile'
          }
        },
        {
          path: '/billing-history',
          name: 'account_billing_history',
          component: () => import('@/views/Account/BillingHistoryView.vue'),
          meta: {
            title: 'Billing History'
          }
        },
      ]
    }
  ]
})

router.beforeEach((to, from, next) => {
  const userStore = useUserStore()
  if (to.name != 'login' && !userStore.loggedIn) next({ name: 'login' })
  else next()
})

export default router